module.exports = __webpack_public_path__ + "img/news1.7f108fa8.png";